@if (products.length !== 0) {
  <h3 class="title">{{ title }}</h3>
  <div class="product-list">
    <mat-grid-list
      [cols]="colPerScreen"
      [rowHeight]="'1:1'"
      gutterSize="10"
      style="flex: 1"
      >
      @for (
        e of [].constructor(
        products.length < colPerScreen
        ? products.length
        : colPerScreen
        ); track
        $index; let i = $index) {
        <mat-grid-tile [colspan]="1">
          <div class="product-item" #pdItem>
            <app-dashboard-card
              [data]="products[i]"
            ></app-dashboard-card>
          </div> </mat-grid-tile>
        }</mat-grid-list>
        <button
          mat-icon-button
          matTooltip="See More"
          (click)="viewMore.emit(filter)"
          >
          <mat-icon>more_horiz</mat-icon>
        </button>
      </div>
    }
